// export const BaseURL = `https://apistaging.wedochallenge.org`;
export const BaseURL = `https://api.wedochallenge.org`;

export const applicationURL = `${BaseURL}/competetions/1/applications`;
export const categoriesURL = `${BaseURL}/competetions/1/categories`;
export const firstStageURL = `${BaseURL}/registeration`;
export const countriesURL = `${BaseURL}/registeration/countries`;
export const organizationsURL = `${BaseURL}/registeration/organizations`;
export const paymentURL = `${BaseURL}/payment`;
